module.exports = __webpack_public_path__ + "static/img/bannar2.1190a5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bannar2.jpg
// module id = 8tZo
// module chunks = 12